import { NextPage } from 'next';
import { createElement } from 'react';
import { useRouter } from 'next/router';
import { withSession as nextAuthWithSession } from '@zopauk/nextjs-auth';

type Props = { authenticate?: boolean };

export function withSession<T extends Props>(Page: NextPage<T>): NextPage<T> {
  // Built once, not per render: nextAuthWithSession returns a new component on every call,
  // and a new component type makes React remount the whole page.
  const ForceLoginPage = nextAuthWithSession<T>(Page, { forceLogin: true });
  const OptionalLoginPage = nextAuthWithSession<T>(Page, { forceLogin: false });

  return function Wrapper(props) {
    const { asPath } = useRouter();

    // Only an explicit `false` makes login optional, so an undefined `authenticate` still forces it
    const SessionPage = props.authenticate === false ? OptionalLoginPage : ForceLoginPage;

    // Keyed by path and query so moving to a different path or query still mounts the page fresh (modules
    // read URL params such as `amount` on mount), while in-page anchor links and re-renders don't remount it
    return createElement<T>(SessionPage, { ...props, key: asPath.split('#')[0] });
  };
}
